import { Link } from "react-router-dom";

import Seo from "../../components/Seo";
import { seoFromPublicPage } from "../../seo/publicPages";
import LegalPublicLayout from "./LegalPublicLayout";
import { LegalSectionBody } from "./LegalSectionBody";
import type { LegalSectionBlock } from "./legalSectionTypes";

const sections: LegalSectionBlock[] = [
  {
    title: "Rolul aplicației",
    content:
      "AIFoiParcurs este un instrument software de organizare și propunere a foilor de parcurs, pe baza informațiilor introduse de utilizator și a regulilor sau algoritmilor aplicației. Orice rezultat al funcției de completare automată foi lipsă are caracter orientativ și necesită verificare umană.",
  },
  {
    title: "Responsabilitatea pentru corectitudinea datelor",
    content:
      "Utilizatorul și/sau compania pe care o reprezintă este singurul responsabil pentru:",
    bullets: [
      "introducerea completă și corectă a datelor, de exemplu kilometri, trasee, scop, consum, alimentări, cantități și date calendaristice;",
      "verificarea existenței și corectitudinii foilor de parcurs pentru toate zilele relevante;",
      "menținerea concordanței cu documentele justificative, cum ar fi bonuri, facturi, evidențe interne, foi de parcurs semnate sau registre, după caz.",
    ],
  },
  {
    title: "Completare automată foi lipsă",
    content:
      "În cazul în care utilizatorul alege să folosească funcția de completare automată foi lipsă, acesta confirmă că:",
    bullets: [
      "foile propuse sunt estimări pe baza punctelor de interes și a tiparelor de deplasare indicate;",
      "își asumă integral verificarea și ajustarea foilor propuse astfel încât să reflecte situația reală.",
    ],
  },
  {
    title: "Validare și eliminarea inconsistențelor",
    content: "Utilizatorul înțelege că mecanismele de validare pot:",
    bullets: [
      "semnala, corecta sau elimina înregistrări considerate inconsistente, de exemplu litri în rezervor sub zero, depășirea capacității rezervorului sau intervale imposibile;",
      "însă nu pot garanta detectarea tuturor erorilor sau conformitatea completă cu situația factuală ori cu cerințe specifice ale autorităților sau organizațiilor.",
    ],
    footer:
      "Prin urmare, utilizatorul rămâne pe deplin responsabil pentru acceptarea și confirmarea rezultatului final.",
  },
  {
    title: "Obligația de verificare înainte de utilizare oficială",
    content:
      "Înainte de export, tipărire, semnare, arhivare sau transmitere către terți, inclusiv autorități, utilizatorul se obligă să efectueze o verificare finală a tuturor foilor de parcurs și să confirme că acestea sunt corecte, complete și conforme cu realitatea.",
  },
  {
    title: "Limitarea răspunderii furnizorului",
    content: "În măsura permisă de lege, furnizorul AIFoiParcurs nu răspunde pentru:",
    bullets: [
      "erori, omisiuni sau neconcordanțe rezultate din date introduse incorect sau incomplet, din funcția de completare automată foi lipsă acceptată fără verificare ori din decizii de validare confirmate de utilizator;",
      "consecințe fiscale, contravenționale, penale sau alte prejudicii rezultate din utilizarea foilor de parcurs completate automat și/sau validate în aplicație.",
    ],
    footer:
      "Utilizatorul acceptă că orice utilizare a rezultatelor aplicației se face pe propria răspundere.",
  },
  {
    title: "Plăți și facturare",
    content:
      "Plățile pentru serviciile oferite prin aplicația AIFoiParcurs se realizează online prin intermediul procesatorului de plăți NETOPIA Payments.",
    bullets: [
      "toate plățile sunt procesate securizat;",
      "AIFoiParcurs nu stochează și nu are acces la datele cardurilor bancare;",
      "după efectuarea plății, utilizatorul va primi confirmarea tranzacției.",
    ],
  },
  {
    title: "Livrarea serviciilor",
    content: "Serviciile oferite de AIFoiParcurs sunt servicii digitale.",
    bullets: [
      "accesul la funcționalitățile aplicației este oferit imediat după confirmarea plății;",
      "nu există livrare fizică de produse.",
    ],
  },
];

export default function TermeniSiConditiiPage() {
  return (
    <LegalPublicLayout>
      <Seo {...seoFromPublicPage("/termeni-si-conditii")} />
      <main className="legal-doc">
        <div className="legal-doc__inner">
          <Link to="/" className="legal-doc__back">
            Înapoi la pagina principală
          </Link>

          <div className="legal-doc__panel">
            <p className="legal-doc__eyebrow">Document legal</p>
            <h1 className="legal-doc__title">Termeni și condiții</h1>
            <p className="legal-doc__lead">
              Asumarea răspunderii pentru date, completare automată foi lipsă și validare.
            </p>
            <p className="legal-doc__p">
              Prin utilizarea aplicației AIFoiParcurs și, în special, prin utilizarea funcțiilor de
              completare automată foi lipsă și/sau a proceselor de validare, inclusiv corectarea sau
              eliminarea inconsistențelor, utilizatorul declară și acceptă următoarele:
            </p>

            <div className="legal-doc__sections">
              {sections.map((section) => (
                <LegalSectionBody key={section.title} section={section} />
              ))}
            </div>

            <div className="legal-doc__declaration">
              <h2>Declarație de asumare</h2>
              <p>
                Prin bifarea căsuței „Am citit și accept” și/sau prin continuarea utilizării
                funcțiilor de completare automată foi lipsă și validare, utilizatorul declară că își
                asumă integral răspunderea pentru completarea foilor lipsă, verificarea și validarea
                tuturor foilor și utilizarea lor în scopuri oficiale sau interne.
              </p>
            </div>
          </div>
        </div>
      </main>
    </LegalPublicLayout>
  );
}
